export default __webpack_public_path__ + "static/colibri-6-web-0aafa6ffcd5ad03f8c814f4d7860cc6b.pdf";